import { useEffect } from 'react';
import { env } from '@/env';
import { register } from '@teamhanko/hanko-elements';

export default function Profile() {
  const lang = navigator.language.split('-')[0] || 'en';

  useEffect(() => {
    // register hanko web component the component
    register(env.VITE_HANKO_API_URL).catch((error) => {
      console.warn('unhandled hanko profile error', error);
      // handle error
    });
  }, []);

  return <hanko-profile lang={lang} />;
}
